<template>
  <div>
    <header>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css">
      <!-- Include CSS do MDB -->
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/mdb-ui-kit/6.4.1/mdb.min.css">
    </header>
    <div class="title-container">
      <h3 class="title">CATÁLOGO DE APIs</h3>
    </div>

    <div style="max-width: 1011px !important;" class="container container-bkg mt-3">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button type="button" id="vendas" @click="setandoMenuAtivo('vendas')" class="btn btn-primary active top-button ml-4" data-mdb-ripple-init>VENDAS</button>
        <button type="button" id="gestao-carteira" @click="setandoMenuAtivo('gestao-carteira')" class="btn btn-primary top-button" data-mdb-ripple-init>GESTÃO CARTEIRA</button>
        <button type="button" id="pos-venda" @click="setandoMenuAtivo('pos-venda')" class="btn btn-primary top-button" data-mdb-ripple-init>PÓS VENDA</button>
      </div>
      <br>

      <table class="table">
        <tbody id="lista-vendas" model="selectedListasVendas" v-for="lista in listas" :key="lista.id" :value="lista.id">
          <tr>
            <th v-if="lista.nome.includes('-clone')" style="padding-left: 10px !important; width: 50px;color: #2FC8B2 !important" scope="row">
              <i v-if="lista.nome.toUpperCase().includes('AUTOMÓVEL')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_carro.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('RESIDENCIAL')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_residencial.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('IMOBILIÁRIO')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_imobiliario.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('CONDOMÍNIO')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_condominio.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('VIDA')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_vida.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('ALUGUEL')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_aluguel.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('GARANTIA')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_garantia.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('EMPRESARIAL')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_empresarial.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('EQUIPAMENTOS')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_equipamentos.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('VIAGEM')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_viagem.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('VIAGEM') === false && lista.nome.toUpperCase().includes('RESIDENCIAL') === false
                && lista.nome.toUpperCase().includes('EQUIPAMENTOS') === false 
                && lista.nome.toUpperCase().includes('EMPRESARIAL') === false && lista.nome.toUpperCase().includes('GARANTIA') === false 
                && lista.nome.toUpperCase().includes('ALUGUEL') === false && lista.nome.toUpperCase().includes('VIDA') === false 
                && lista.nome.toUpperCase().includes('CONDOMÍNIO') === false && lista.nome.toUpperCase().includes('IMOBILIÁRIO') === false 
                && lista.nome.toUpperCase().includes('AUTOMÓVEL') === false
                && lista.nome.toUpperCase().includes('GESTÃO CARTEIRA') === false
                && lista.nome.toUpperCase().includes('PÓS VENDA') === false"
                class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_passos.svg" class="others-svg">
              </i>
            </th>
            <th v-if="!lista.nome.includes('-clone')" style="padding-left: 10px !important; width: 50px; margin-left:350px" scope="row">
              <i v-if="lista.nome.toUpperCase().includes('AUTOMÓVEL')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_carro.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('RESIDENCIAL')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_residencial.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('IMOBILIÁRIO')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_imobiliario.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('CONDOMÍNIO')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_condominio.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('VIDA')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_vida.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('ALUGUEL')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_aluguel.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('GARANTIA')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_garantia.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('EMPRESARIAL')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_empresarial.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('EQUIPAMENTOS')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_equipamentos.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('VIAGEM')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_viagem.svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('VIAGEM') === false && lista.nome.toUpperCase().includes('RESIDENCIAL') === false
                && lista.nome.toUpperCase().includes('EQUIPAMENTOS') === false 
                && lista.nome.toUpperCase().includes('EMPRESARIAL') === false && lista.nome.toUpperCase().includes('GARANTIA') === false 
                && lista.nome.toUpperCase().includes('ALUGUEL') === false && lista.nome.toUpperCase().includes('VIDA') === false 
                && lista.nome.toUpperCase().includes('CONDOMÍNIO') === false && lista.nome.toUpperCase().includes('IMOBILIÁRIO') === false 
                && lista.nome.toUpperCase().includes('AUTOMÓVEL') === false
                && lista.nome.toUpperCase().includes('GESTÃO CARTEIRA') === false
                && lista.nome.toUpperCase().includes('PÓS VENDA') === false"
                class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_passos.svg" class="others-svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('GESTÃO CARTEIRA')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_apolice.svg" class="others-svg">
              </i>
              <i v-if="lista.nome.toUpperCase().includes('PÓS VENDA')" class="icon-line">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_doc_apolice.svg" class="others-svg">
              </i>
            </th>
            <td v-if="lista.nome.includes('-clone')" class="name-line" style="color: #2FC8B2 !important;padding-left: 35px !important;padding-top: 3% !important;">
              {{lista.nome.toUpperCase()}}
            </td>
            <td v-if="!lista.nome.includes('-clone')" class="name-line" style="padding-left: 35px !important;padding-top: 3% !important;">
              {{lista.nome.toUpperCase()}}
            </td>
            <td></td>
            <td v-if="lista.nome.includes('-clone')" style="width: 120px;color: #2FC8B2 !important">
              VERSÃO {{lista.versao}}
            </td>
            <td v-if="!lista.nome.includes('-clone')" style="width: 120px">
              VERSÃO {{lista.versao}}
            </td>
            <td style="width: 75px">
              <button class="btn btn-primary pen-button" @click="abrirEdicaoCatalogo(lista)">
                <i style="font-size: 13px !important;" class="fa-solid fa-pen"></i>
              </button>
            </td>
            <td v-if="!lista.nome.includes('-clone')" style="width: 104px" @click="clonarLinha(lista.idCatalogoApi, lista.grupo)">
              <button class="btn btn-primary copy-button">
                <i style="font-size: 13px !important;" class="fa-solid fa-copy"></i>
              </button>
            </td>
            <td v-if="lista.nome.includes('-clone')" style="width: 104px" @click="deletarClone(lista.idCatalogoApi, lista.grupo)">
              <button class="btn btn-primary">
                <i style="font-size: 13px !important;" class="fa-solid fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="loader" v-if="showModal">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>
  </div>
</template>
 
<script>
import * as alertUtils from '@/utils/alert';
import FormNotch from './FormNotch.vue';

import $ from 'jquery'; // Importando jQuery
import 'mdb-ui-kit'; // Importando o JavaScript do MDB

export default {
  data() {
    return {
      selectedListasVendas: "",
      showModal: false,
      showList: false,
      listas: []
    };
  },
  components: { 
    FormNotch
  },
  methods: {
      possuiClone(catalogo) {

      if ((catalogo.nome || '').includes('-clone')) return false;

      const nomeCloneEsperado = `${catalogo.nome}-clone`;

      return (this.listas || []).some(l => l && l.nome === nomeCloneEsperado);
    },

    abrirEdicaoCatalogo(catalogo) {
      console.log("Teste abrir editar catalogo", catalogo)
      if (this.possuiClone(catalogo)) {
        alertUtils.alertError('Este catálogo possui clone. Caso haja necessidade de edição, edite o clone.');
        return;
      }

      window.location.href =
        `/massificados/corporativo/gerenciador-parceiros-ui/#/manutencao-catalogo-servico/${catalogo.idCatalogoApi}`;
    },
    clonarLinha(idCatalogo, grupo) {
      this.clonarCatalogo(idCatalogo, grupo);
    },
    setandoMenuAtivo(nome) {
      $('#'+nome).addClass('active');

      this.pesquisar(nome.charAt(0).toUpperCase());

      if('vendas' != nome) {
        $('#vendas').removeClass('active');
      }

      if('gestao-carteira' != nome) {
        $('#gestao-carteira').removeClass('active');
      }

      if('pos-venda' != nome) {
        $('#pos-venda').removeClass('active');
      }
    },
    async clonarCatalogo(idCatalogo, grupo) {
      let urlApi;
      let method;
      let requestOptions;
     
      urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/clonar/'+ idCatalogo;
      method = 'GET';

      requestOptions = {
        method: method
      };

      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if(response.ok) {
              let mensagem = (await response.text()).length === 12 ? "Catálogo já clonado!": "Clone realizado com sucesso!";
              
              if(mensagem === "Catálogo já clonado!"){
                alertUtils.alertError(mensagem);
              } else {
                alertUtils.alertSuccess(mensagem);
              }
              
              this.pesquisar(String(grupo)); 

              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then((data) => {})
          .catch((error) => {
            // loaderUtils.removeLoader();
            console.log(error)
          }).finally(() => 'loaderUtils.removeLoader()');
         
      } catch (error) {
        console.error('Erro ao realizar busca:', error);
        alertUtils.alertError('Erro ao realizar busca:'+ error);
      }

      // loaderUtils.removeLoader();
    },
    async deletarClone(idCatalogo, grupo) {
      let urlApi;
      let method;
      let requestOptions;
     
      urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/deletar-clone/'+ idCatalogo;
      method = 'POST';

      requestOptions = {
        method: method
      };

      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if (response.ok) {
              alertUtils.alertSuccess("Catálogo clonado excluido!");

              this.pesquisar(String(grupo));

              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then((data) => {})
          .catch((error) => {
            console.log(error)
          }).finally(() => 'loaderUtils.removeLoader()');
         
      } catch (error) {
        console.error('Erro ao realizar busca:', error);
        alertUtils.alertError('Erro ao realizar busca:'+ error);
      }
    },
    async pesquisar(grupo) {
      let urlApi;
      let method;
      let requestOptions;
     
      urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/consultar-grupo/' + grupo;
      method = 'GET';

      requestOptions = {
        method: method
      };

      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then((data) => {
            this.showList = true;

            this.listas = data;
          })
          .catch((error) => {
            console.log(error)
            alertUtils.alertError('Não encontramos nenhum resultado!', 'Fechar');
          }).finally(() => 'loaderUtils.removeLoader()');
         
      } catch (error) {
        console.error('Erro ao realizar busca:', error);
        alertUtils.alertError('Erro ao realizar busca:'+ error);
      }
    }
  },
  mounted() {
    this.pesquisar('V');

    $(".btn-group").attr("style", "margin-left: 12rem !important");
  }
}
</script>

<style scoped>
@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-sistemas/css/consulta-catalogo/style.css';
</style>
